module.exports = __webpack_public_path__ + "img/img_32389_0_155.b4fc434c.png";